export default "__VITE_ASSET__BjFCQNY2__"